import { format } from 'date-fns'

export const formatDate = (dateString?: string) => {
  if (!dateString) return ''

  try {
    const date = new Date(dateString)
    return (
      <>
        {format(new Date(date), 'yyyy-MM-dd')}
        <br />
        {format(new Date(date), 'HH:mm')}
      </>
    )
    // return format(new Date(date), 'yyyy-MM-dd HH:mm')
  } catch (error) {
    return dateString
  }
}
